import React, { useEffect, useState } from 'react'
import { AdminModal, AdminModalContent, AdminModalFooter, AdminModalHeader, AdminModalMiddle, AdminModalTitle } from '@/src/pages/admin/components/modal';
import outlined from '@material-tailwind/react/theme/components/timeline/timelineIconColors/outlined';
import { edit_option_props } from '../variationComponent';
import { Input } from '@/src/components/ui/input';
import { Button } from '@/src/components/ui/button';
import useFormValidatonCustom, { validationObject } from '@/src/hooks/form_validation_hook';
import { useRESTapi } from '@/src/hooks/rest_API';
import { ProductVariationOption } from '@/src/types';
import { Loader2 } from 'lucide-react';

type props = {
    edit_option_modal_config: edit_option_props,
    set_edit_option_modal_config: (value: edit_option_props) => any,
    reload_product: () => any

}

type formDataType = {
    optionName: string
}
export default function OptionEditModal(props: props) {


    const [formData, setFormData] = useState<formDataType>({
        optionName: ''
    })
    const validationObject = {
        optionName: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        }
    } satisfies validationObject

    const { performAllValidation, performValidationOf, errorData, setErrorData } = useFormValidatonCustom<formDataType>({
        validationObject: validationObject
    })

    const [is_loading, set_is_loading] = useState(false)
    const api = useRESTapi()

    const onchange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let formDataNew: formDataType = { ...formData }
        switch (e.target.name) {
            case 'optionName':
                formDataNew.optionName = e.target.value
                break;

            default:
                break;
        }
        performValidationOf(e.target.name, formDataNew)
        setFormData(formDataNew)
    }



    const udpateOption = async () => {
        set_is_loading(true)
        if (performAllValidation(formData) === true) {
            try {

                const res = await api.put<{ success: boolean, data: ProductVariationOption, errors: any, message: string }>({
                    mode: 'admin',
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/variation_options/${props.edit_option_modal_config.option?.id}`,
                    body: {
                        M07_Value : formData.optionName
                    }
                })
                if (res.data.success === true) {
                    props.set_edit_option_modal_config({ show: false,showDeleteModal:false })
                    props.reload_product()
                    clear_data()
                } else {
                    alert(res.data.message)
                }

            } catch (error) {
                console.log(error)
                alert('server error')
            }
        }
        set_is_loading(false)
    }

    function clear_data(){
        setFormData({
            optionName:''
        })
    }

    useEffect(
        () => {
            if (props.edit_option_modal_config.show && props.edit_option_modal_config.option) {
                setFormData({
                    optionName: props.edit_option_modal_config.option.name
                })
            }
        }, [props.edit_option_modal_config.show]
    )


    return (
        <AdminModal show={props.edit_option_modal_config.show} setShow={(show) => {
            if (is_loading === false) {
                props.set_edit_option_modal_config({
                    show: show,
                    option: show ? props.edit_option_modal_config.option : undefined,
                    showDeleteModal:false,
                    
                })
            }
        }} >
            <AdminModalContent disableCloseButton={is_loading} >
                <AdminModalHeader>
                    <AdminModalTitle>
                        Option
                    </AdminModalTitle>
                </AdminModalHeader>
                <AdminModalMiddle className=' !max-w-48 !min-w-48'>
                    <Input disabled={is_loading} name='optionName' onChange={onchange} value={formData.optionName} />
                    <p className=' text-red-500 text-xs mt-2'>{errorData.optionName}</p>
                </AdminModalMiddle>
                <AdminModalFooter>
                    <Button disabled={is_loading} onClick={() => props.set_edit_option_modal_config({ show: false,showDeleteModal:false })} variant={'outline'}>Cancel</Button>
                    <Button disabled={is_loading} onClick={udpateOption}>{is_loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Edit</Button>
                </AdminModalFooter>
            </AdminModalContent>
        </AdminModal>
    )
}
